<a [class]="'link ' + fromSize(size) + ' ' + fromVisibility(visibility)"
   [class._disabled]="disabled">
    <ng-content></ng-content>
</a>
